import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom'
import { getParameterByName } from "../../helpers";

import './home.css'
import Leafs from '../../components/leafs';

class Home extends Component {
  state = {
    animated: false,
    token: null,
  }

  componentDidMount() {
    console.log(this.props)

    setTimeout(() => {
      this.setState({animated: true})
    }, 200)
  }

  createPostcard = () => {
    window.ga('send', 'event', 'button', 'click', 'createPostcard');
  }

  render() {
    const { animated } = this.state

    return (
      <div>
        <div className={`home ${animated ? 'animated' : ''}`}>
          <div className="home__left">

              <h1>Зафутболь открытку</h1>

              <div className="home__content">
                {/*<p className="text-medium">Гол забивает Анастасия Ли!</p>*/}
                <p>Победителями в конкурсе «Зафутболь открытку» от платежной системы «Мир» стали Светлана Павлова и Анастасия Ли. Светлана отправляется на матч нашей сборной в Бельгии, а Анастасия – на игру в Казахстане! Поздравляем и желаем хорошей поездки!</p>
                <Link className="button" to="card" onClick={this.createPostcard}>Создать открытку</Link>
              </div>

          </div>
          <div className="home__right">

            <div className="steps">
              <div className="step step--1">
                <div className="step__num">1</div>
                <div className="step__text">Выбери <br />открытку</div>
              </div>
              <div className="step__divider  step--1"></div>
              <div className="step  step--2">
                <div className="step__num">2</div>
                <div className="step__text">Поделись <br />в соцсетях </div>
              </div>
              <div className="step__divider  step--2"></div>
              <div className="step  step--3">
                <div className="step__num">3</div>
                <div className="step__text">Получи шанс <br />выиграть приз</div>
              </div>
            </div>

            <div className="player">
              <div className="player__name">Марио Фернандес</div>
              <div className="player__role">Защитник Национальной сборной России по футболу</div>
            </div>
          </div>
          <div className="card__note -mobile">*В розыгрыше могут принимать участие пользователи старше 18 лет</div>

        </div>
        <div className="player__pic"></div>
        <Leafs></Leafs>

      </div>
    );
  }
}

export default withRouter(Home);